import { CSSProperties, FC } from 'react';

import { ChannelList } from './channelOverview/ChannelList';
import { AppStoreNotificationBanner } from './AppStoreNotificationBanner';

import styles from './CoverPageHero.module.css';

interface Props {
  programPointsComponent?: JSX.Element;
  image?: string;
  playerComponent?: JSX.Element;
}

export const CoverPageHero: FC<Props> = ({ programPointsComponent, image, playerComponent }) => {
  const sectionStyle = {
    backgroundImage: `url(${image})`,
  };

  return (
    <div className={styles.hero} style={sectionStyle}>
      <AppStoreNotificationBanner />
      <div className={styles.overlay} />
      <ChannelList />
      <div className={styles.player}>
        <div className={styles.playback}>{playerComponent}</div>
      </div>
      <div style={{ '--scroller-margin': '10%' } as CSSProperties}>{programPointsComponent}</div>
    </div>
  );
};
